// extracted by mini-css-extract-plugin
module.exports = {"otpGrid":"_2atbv","textError":"_1gPqZ","otpInputWrap":"_3RIDN","error":"lERu9","loading":"_1Pbd5"};